import { useRef } from "react";
import { ExploreInteractionRow } from "@/v2/entities/explore/Explore.model";

export function useStickySelectedInteraction(
  selectedInteractionId: string | undefined,
  interactions: ExploreInteractionRow[]
) {
  const cachedRef = useRef<ExploreInteractionRow>();

  if (selectedInteractionId == null) {
    cachedRef.current = undefined;
    return undefined;
  }

  const fromList = interactions.find(
    (row) => row.displayId === selectedInteractionId
  );

  if (fromList != null) {
    if (cachedRef.current?.displayId === fromList.displayId) {
      return cachedRef.current;
    }

    cachedRef.current = fromList;
    return fromList;
  }

  return cachedRef.current?.displayId === selectedInteractionId
    ? cachedRef.current
    : undefined;
}
